import * as React from 'react';
import NavMenu from './NavMenu';
import EnvironmentBanner from './EnvironmentBanner';
import { AuthStateContext } from '../Services/AuthContext';
import {  Container } from 'reactstrap'
import { useState } from 'react';
import { useEffect } from 'react';
import { HeightProvider } from '../Services/HeightContext';
import useWindowDimensions from '../utils/measureDomNode'

const Layout = ({  children }) => {
    const [navEl, setNavEl] = useState(null);
    const [bodyHeight, setbodyHeight] = useState();
    const { height } = useWindowDimensions();

    // Watch the nav wrapper so the body resizes when the banner or nav changes height.
    useEffect(() => {
        if (!navEl) return;

        const updateBodyHeight = () => {
            const newHeight = height - (navEl.clientHeight + 15);
            if (newHeight !== 0) {
                setbodyHeight(newHeight);
            }
        };

        updateBodyHeight();
        const observer = new ResizeObserver(updateBodyHeight);
        observer.observe(navEl);
        return () => observer.disconnect();
    }, [navEl, height]);
    
    return height?<div>
        
            <AuthStateContext.Consumer>
                {
                    value => {

                        const [user] = value ? value : [null];
                        if (user && user.jwt && user.terms) {

                            return (<div >
                                <div ref={setNavEl}>
                                <EnvironmentBanner />
                                <NavMenu />
                                </div>
                                <Container style={{ height: bodyHeight }}>
                                    <HeightProvider height={bodyHeight}>
                                        {children}
                                    </HeightProvider>
                                    </Container>
                                </div>)
                       
                        }
                        else return <React.Fragment>
                                {children}
                              
                        </React.Fragment>
                    }
                }
                </AuthStateContext.Consumer>
        
        </div >: null
   

};

export default Layout; 
